<script lang="ts" context="module">
	import { getClassicWebUrl } from "../currentUser";
	import ToolbarItem from "./ToolbarItem.svelte";
</script>

<script lang="ts">
	const CLASSIC_WEB_URL = getClassicWebUrl();
</script>

<ToolbarItem link="{CLASSIC_WEB_URL}/login?s=toolbar-button">
	<img
		class="mr-2.5"
		src="https://cdn.smore.com/images/toolbar-logo.f046a055.svg"
		width="96"
		alt="Go to Smore home page."
		aria-label="Go to Smore home page." />
</ToolbarItem>
